export const CORE_PACKAGES_PREDEFINED_DISCOUNT_KEYS = {
	15: 15,
	30: 30,
	45: 45,
	CUSTOM: 'CUSTOM',
};
